import React from "react";
import { connect } from "react-redux";
import { getWidgetSpecificIsVisible } from "@utils/index";
import { CommonProps } from "@utils/interface";
import {
  TableContainer,
  Heading,
  TableContent,
  Column,
  SpecItem,
  SpecLabel,
  SpecValue,
  HeadingWrapper,
  DisclaimerText,
  TableContainerWrapper,
  DisclaimerTextContainer
} from "./styles";

export interface IFeatureTableItem {
  label: string;
  value: string;
}

export interface IFeatureTable extends CommonProps {
  heading?: string;
  items?: IFeatureTableItem[];
  disclaimerText?: string;
}

const mapStateToProps = function (state: any, ownProps: any) {
  return {
    is_visible: getWidgetSpecificIsVisible(
      state.configuration?.normalisedConfig,
      ownProps.id
    )
  };
};

const FeatureTable = (props: IFeatureTable) => {
  const { 
    heading, 
    is_visible,
    items,
    disclaimerText
  } = props;
  const midPoint = Math.ceil((items?.length || 0) / 2);
  const leftColumnItems = items?.slice(0, midPoint);
  const rightColumnItems = items?.slice(midPoint);
  return is_visible ? (
    <TableContainerWrapper>
    <TableContainer>
      <HeadingWrapper>
      <Heading>{heading}</Heading>
      </HeadingWrapper>
      <TableContent>
        <Column>
          {leftColumnItems?.map((item, index) => (
            <SpecItem key={index}>
              <SpecLabel>{item.label}</SpecLabel>
              <SpecValue>{item.value}</SpecValue>
            </SpecItem>
          ))}
        </Column>
        <Column>
          {rightColumnItems?.map((item, index) => (
            <SpecItem key={index}>
              <SpecLabel>{item.label}</SpecLabel>
              <SpecValue>{item.value}</SpecValue>
            </SpecItem>
          ))}
        </Column>
      </TableContent>
    </TableContainer>
    {disclaimerText && (
      <DisclaimerTextContainer>
        <DisclaimerText>{disclaimerText}</DisclaimerText>
      </DisclaimerTextContainer>
    )}
    </TableContainerWrapper>
  ) : <></>;
};

export default connect(mapStateToProps)(FeatureTable);
